import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function SaveGrant({
  setShowAddModal,
  refreshFunc,
  handleInitialLabelImport,
}) {
  /*   All States
   ********************************************* */
  const dispatch = useDispatch();

  const REAUTH_FLAG_KEY = "emailClientReauth";
  const REAUTH_EMAIL_KEY = "emailClientReauthEmail";

  const [searchParams, setSearchParams] = useSearchParams();

  const clearReauthMarkers = () => {
    sessionStorage.removeItem(REAUTH_FLAG_KEY);
    sessionStorage.removeItem(REAUTH_EMAIL_KEY);
  };

  /*   All Functions
   ******************************************** */
  const saveGrant = async (code) => {
    const isReauthFlow = sessionStorage.getItem(REAUTH_FLAG_KEY) === "true";
    const reauthEmail = sessionStorage.getItem(REAUTH_EMAIL_KEY);
    try {
      const { data } = await API.post(
        "/email-grants/auth/grant",
        { code },
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        setSearchParams({});
        await refreshFunc();
        if (!isReauthFlow) {
          handleInitialLabelImport(data?.grantEmail);
        }
        setShowAddModal(false);
        clearReauthMarkers();
        dispatch(
          setNotification({
            message: "Email client connected successfully",
            type: "success",
          })
        );

        // navigate
        // navigate("/email/inbox");
      } else {
        throw new Error("Failed to get authorization URL");
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      clearReauthMarkers();
    }
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      const code = searchParams.get("code");
      if (code) {
        saveGrant(code);
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [searchParams]);

  return (
    <div style={{ height: "200px" }} className="">
      <div className="card h-100 shadow-none">
        <Spinner />
        <div className="card-body  flex-center flex-column">
          <div className="text-center">
            <h3 className="card-title">Saving Authorization Grant...</h3>
          </div>
        </div>
      </div>
    </div>
  );
}
